import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class SheetsAdminService extends BaseService<any> {
  constructor() {
    super(`google-sheets`);
  }

  // Получаем список файлов
  getFiles = async (queryParams: object = {}) => {
    return appAxios.get(`${this.pathWithOrg()}/files`, { params: queryParams });
  };

  // Получаем информацию о файле
  getSheet = async (sheetID: string) => {
    return appAxios.get(`${this.pathWithOrg()}/sheet-details/${sheetID}`);
  };

}

export default new SheetsAdminService();
